import { useEffect, useState } from "react"
import { dictionaryCRUD } from "../../../../actions/dictionary"


export const ResidentialDetail = (props) => {

  const {data, step1, setStep1, step2, setStep2} = props

  const [relation, setRelation] = useState(null)

  useEffect(() => {
    if (!data || !data.dictionary_relation_to_head) return;

    setTimeout(() => {
      dictionaryCRUD.loadDictionaryItemById(data.dictionary_relation_to_head).then((resp) => {
        setRelation(resp.data && resp.data.dictionary_item_name_en)
      })
    },500)
  },[data])

  return (
    <>
      <div>
        <div className="row">
            <div className="col-lg-6 col-sm-12">
                <div className="mb-3">
                    <label className="form-label" >Relation to Head</label>
                    <input type="text" className="form-control border-dashed" id="steparrow-gen-info-email-input" value={relation ? (relation).toUpperCase() : 'N/A'}  readOnly/>
                </div>
            </div>
            <div className="col-lg-6 col-sm-12">
                <div className="mb-3">
                    <label className="form-label" >Birth Certificate Number</label>
                    <input type="text" className="form-control border-dashed" id="steparrow-gen-info-username-input" value={data.birth_certificate_no ? (data.birth_certificate_no).toUpperCase() : 'N/A'}  readOnly/>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-lg-4 col-sm-12">
                <div className="mb-3">
                    <label className="form-label" >Zanzibar ID</label>
                    <input type="text" className="form-control border-dashed" id="steparrow-gen-info-email-input" value={data.zan_id_no ? (data.zan_id_no).toUpperCase() : 'N/A'} readOnly/>
                </div>
            </div>
            <div className="col-lg-4 col-sm-12">
                <div className="mb-3">
                    <label className="form-label" >National ID (NIDA)</label>
                    <input type="text" className="form-control border-dashed" id="steparrow-gen-info-username-input" value={data.nida ? (data.nida).toUpperCase() : 'N/A'} readOnly/>
                </div>
            </div>
            <div className="col-lg-4 col-sm-12">
              <div className="mb-3">
                <label className="form-label" >Passport Number</label>
                <input type="text" className="form-control border-dashed" id="steparrow-gen-info-password-input" value={data.pasport_no ? (data.pasport_no).toUpperCase() : 'N/A'} readOnly/>
              </div>
            </div>
        </div>
      </div>
      <div class="d-flex align-items-start gap-3 mt-4">
      <button type="button" class="btn btn-light btn-label" onClick={() => setStep1(!step1)} ><i class="bi bi-chevron-double-left label-icon align-middle fs-16 me-2"></i> Previous</button>
          <button type="button" class="btn btn-success btn-label right ms-auto" onClick={() => setStep2(!step2)}><i className="bi bi-chevron-double-right label-icon align-middle fs-16 ms-2"></i>Next</button>
      </div>
    </>
  )

}